<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="m-l-14">
        <el-checkbox border v-model="filters.isHandle" @change="checkChange"
          >只看待处理申报</el-checkbox
        >
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          size="small"
          v-model.trim="filters.reportName"
          placeholder="申报名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="query"></butn>
        <butn title="重置" @click="reset" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      filters: {
        isHandle: true,
      },
    };
  },
  created() {},
  methods: {
    query() {
      this.$emit("search", {
        ...this.filters,
        isHandle: this.filters.isHandle ? 1 : 0,
      });
    },
    reset() {
      this.filters = {
        isHandle: false,
      };
      this.query();
    },
    checkChange() {
      this.query();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
  